import Resource from '@/api/resources/Resource'

class SampleRevisionServices extends Resource {
    async getAllSampleRevisions(caseId, sampleId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/revisions`)
        return response.data
    }

    async getSampleRevision(caseId, sampleId, revisionId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/revisions/${revisionId}`)
        return response.data
    }

    async getSampleUnfinishedRevision(caseId, sampleId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/revisions/unfinished`)
        return response.data
    }
}

export default new SampleRevisionServices()
